import React, { useState } from "react";
import { withNamespaces } from 'react-i18next';
import { Col } from "reactstrap";
import ContainerSpecifications from '../../../../../resources/Containers_Specifications.png'
import Axios from "axios";
import { saveAs } from "file-saver";
import { Icon } from "semantic-ui-react";


function ContainerSpecificatrions(params) {

  const [loading, setloading] = useState(false);
  const [pdf] = useState({
    Img: 'https://magiclog.blob.core.windows.net/europartnerspic/pdficon.png',
    Pdf: "https://magiclog.blob.core.windows.net/onboardfile/Container Specifications - OBL experience.pdf",
    Name: 'Container Specifications - OBL experience',
    id: 'container_pdf'
  })

  function Download(pdf, name, id) {
    const linkSource = pdf;

    Axios({
      method: 'get',
      url: encodeURI(linkSource),
      responseType: 'blob',
      // Headers: {
      //   'Access-Control-Allow-Origin': 'http://localhost:4900/', // Replace with your website's origin 
      // },
    }).then(function (response) {
      saveAs(
        response.data,
        `${name}`
      );

      setloading(false)
      // document.getElementById(id).className = "iconPdfOff"
    }).catch(function (error) {
      console.log("🚀 ~ file: index.js:33 ~ Download ~ error:", error)
    });
  }


  return (
    <>
      <Col xs={12} md={12} lg={12}  >
        <div className="d-flex justify-content-end">
          {
            loading ?
              <div className="iconPdfOff">
                <Icon
                  loading={loading}
                  style={{ marginTop: "9px" }}
                  name="circle notch"
                  size="large"
                />
              </div>
              :
              <img
                className="iconPdfOff"
                src={pdf.Img}
                alt=""
                width={35}
                onClick={() => {
                  setloading(true)
                  setTimeout(() => {
                    Download(pdf.Pdf, pdf.Name, pdf.id)
                  }, 2000)

                  // let elm = document.getElementById(pdf.id)
                  // document.getElementById(pdf.id).className = "iconPdfOn imgr"
                  // setTimeout(() => {
                  //   if (elm.className === 'iconPdfOn imgr') {
                  //     Download(pdf.Pdf, pdf.Name, pdf.id)
                  //   }
                  // }, 2000)
                }}
                title={params.t("download_container_pdf")}
                id={pdf.id}
              />
          }
        </div>
        <div className="d-flex justify-content-center">
          <img src={ContainerSpecifications} alt="" style={{ width: '80%', height: 'auto' }} />
        </div>
      </Col>
    </>
  )
}

export default withNamespaces()(ContainerSpecificatrions);
